// Dark / light mode toggle button.
// Persists the explicit choice in localStorage; the small inline script in
// default.hbs applies that choice before first paint to avoid a flash.
(function () {
    var STORAGE_KEY = 'casper_porto_color_scheme';
    var root = document.documentElement;
    var toggles = document.querySelectorAll('[data-color-toggle]');
    if (!toggles.length) return;

    function isDark() {
        if (root.classList.contains('dark-mode')) return true;
        if (root.classList.contains('auto-color')) {
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
        return false;
    }

    function reflect(dark) {
        for (var i = 0; i < toggles.length; i++) {
            toggles[i].setAttribute('aria-pressed', String(dark));
        }
    }

    reflect(isDark());

    for (var i = 0; i < toggles.length; i++) {
        toggles[i].addEventListener('click', function () {
            var next = !isDark();
            root.classList.toggle('dark-mode', next);
            root.classList.remove('auto-color');
            reflect(next);
            try {
                localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light');
            } catch (e) {}
        });
    }
})();
